import React, { useState } from 'react';

const PricingCard = ({ title, price, description, features, buttonText, isPopular, onSubscribe }) => (
    <div className={`relative p-8 bg-white rounded-2xl border ${isPopular ? 'border-pink-500 shadow-xl' : 'border-gray-200 shadow-sm'} flex flex-col`}>
        {isPopular && (
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                <span className="bg-pink-500 text-white px-3 py-1 rounded-full text-sm font-bold uppercase tracking-wider">Most Popular</span>
            </div>
        )}
        <h3 className="text-2xl font-bold text-gray-900 mb-2">{title}</h3>
        <p className="text-gray-500 mb-6 min-h-[48px]">{description}</p>
        <div className="mb-6">
            <span className="text-4xl font-extrabold text-gray-900">${price}</span>
            {price !== '0' && <span className="text-gray-500 font-medium">/month</span>}
        </div>
        <ul className="space-y-4 mb-8 flex-1">
            {features.map((feature, idx) => (
                <li key={idx} className="flex items-start">
                    <span className="text-green-500 mr-2">✓</span>
                    <span className="text-gray-600 text-sm">{feature}</span>
                </li>
            ))}
        </ul>
        <button 
            onClick={onSubscribe}
            className={`w-full py-3 rounded-lg font-bold transition-colors ${isPopular ? 'bg-pink-500 text-white hover:bg-pink-600' : 'bg-gray-100 text-gray-900 hover:bg-gray-200'}`}
        >
            {buttonText}
        </button>
    </div>
);

export default function PricingTiersPage({ navigateTo }) {
    const [billingCycle, setBillingCycle] = useState('monthly');

    const handleSubscribe = (tier) => {
        console.log(`Subscribing to ${tier}`);
        // In reality, this would call your Stripe checkout session utility
    };

    return (
        <div className="min-h-screen bg-gray-50 py-20 px-4 sm:px-6 lg:px-8">
            <div className="max-w-7xl mx-auto">
                <div className="text-center max-w-3xl mx-auto mb-16">
                    <h1 className="text-4xl font-extrabold text-gray-900 sm:text-5xl">Simple, transparent pricing</h1>
                    <p className="mt-4 text-xl text-gray-500">Whether you're hosting a single party or running a full-scale rental business, we have a plan for you.</p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
                    <PricingCard 
                        title="Free Planner"
                        price="0"
                        description="Everything you need to host a great event."
                        features={[
                            "Browse & Book Rentals",
                            "Basic E-vites (Up to 50 guests)",
                            "Standard Event Checklist",
                            "Guest Booking Lookup"
                        ]}
                        buttonText="Get Started"
                        onSubscribe={() => navigateTo('home')}
                    />
                    <PricingCard 
                        title="Planner Pro"
                        price="12"
                        description="Advanced tools for weddings and large events."
                        isPopular={true}
                        features={[
                            "AI Party Planner & Assistant",
                            "Unlimited Premium E-vites",
                            "Custom Wedding Website",
                            "Potluck & Song Requests",
                            "RSVP SMS Reminders"
                        ]}
                        buttonText="Upgrade to Pro"
                        onSubscribe={() => handleSubscribe('planner-pro')}
                    />
                    <PricingCard 
                        title="Vendor Business"
                        price="29"
                        description="The complete OS for your rental business."
                        features={[
                            "Unlimited Listings",
                            "Automated Stripe Payouts",
                            "AI Listing Descriptions",
                            "Contract Generation",
                            "Calendar & Buffer Days"
                        ]}
                        buttonText="Become a Vendor"
                        onSubscribe={() => handleSubscribe('vendor')}
                    />
                </div>
            </div>
        </div>
    );
}
